const R_VAL_ComputeTotal = (itm, temp) => {

console.log('R_VAL_ComputeTotal VIT_INV_AMT_FCX: '+document.getElementsByName('VIT_INV_AMT_FCX')[0].value);

const INV=document.getElementsByName('VIT_INV_AMT_FCX')[0].value.replace(/,/g, "")*document.getElementsByName('VIT_INV_CUR_RAT')[0].value.replace(/,/g, "");
temp.TAR_PRI=temp.INV.toFixed(2);
}//end func



export default R_VAL_ComputeTotal;



/*
		if (EventStack.isImporting()) {
			return;
		}

		DataField d = e.getDataField();
		D_asysad sad = (D_asysad) d.getDocument();
		if (sad == null) {
			return;
		}

		if (!sad.getOperationClassName().equals(OC_RETRIEVE) && !sad.getOperationClassName().equals(OC_NEW)) {
			return;
		}
		// Invoice foreign currency
		BigDecimal x, y, z;

		if (FCX.equals(d.getName())) {

			DataField total = sad.ds(VGS).ds(TOT).de(FCX);
			// double x = d.getDouble(0);
			x = new BigDecimal(AWUtil.removeCommas(d.getString("0").trim()));
			// System.out.println("Field total " + x.doubleValue() + " " +
			// x.toString());
			if (x.doubleValue() == 0)
				return;

			// double y = total.getDouble(0);
			y = new BigDecimal(AWUtil.removeCommas(total.getString("0").trim()));
			// System.out.println("Calculated total " + y.doubleValue() + " " +
			// y.toString());

			if ("I".equals(sad.ds(PTY).de(FLW).getString(""))) {
				DS_Itm itm = (DS_Itm) d.getSubDocument();
				itm.ds(TAR).de(PRI).setDouble(x.doubleValue());
			}

			// x is the old value
			z = new BigDecimal("0");
			if (e.getId() == DATA_CHANGING.getId()) {
				z = y.subtract(x);
				total.setDouble(z.doubleValue());
				// System.out.println("total now is changing " + z.toString());
				total.changeOriginalContent();

			} else {
				// x is the new value
				if (e.getId() == DATA_CHANGED.getId()) {
					z = y.add(x);
					// System.out.println("total now is changed " +
					// z.toString());
					total.setDouble(z.doubleValue());
					total.changeOriginalContent();
				}
			}
		}

		if (NMU.equals(d.getName())) {

			DataField total = sad.ds(VGS).ds(TOT).de(NMU);
			x = new BigDecimal(AWUtil.removeCommas(d.getString("0").trim()));
			if (x.doubleValue() == 0)
				return;

			y = new BigDecimal(AWUtil.removeCommas(total.getString("0").trim()));

			z = new BigDecimal("0");
			if (e.getId() == DATA_CHANGING.getId()) {
				z = y.subtract(x);
				total.setDouble(z.doubleValue());
				total.changeOriginalContent();

			} else {
				if (e.getId() == DATA_CHANGED.getId()) {
					z = y.add(x);
					total.setDouble(z.doubleValue());
					total.changeOriginalContent();
				}
			}
		}
		// Gross weight

		if (GRS.equals(d.getName())) {

			DataField total = sad.ds(VGS).ds(TOT).de(GRS);
			// double x = d.getDouble(0);
			x = new BigDecimal(AWUtil.removeCommas(d.getString("0").trim()));
			if (x.doubleValue() == 0)
				return;
			// double y = total.getDouble(0);
			y = new BigDecimal(AWUtil.removeCommas(total.getString("0").trim()));
			// x is the old value
			if (e.getId() == DATA_CHANGING.getId()) {
				z = y.subtract(x);
				total.setDouble(z.doubleValue());
			} else {
				// x is the new value
				if (e.getId() == DATA_CHANGED.getId()) {
					z = y.add(x);
					total.setDouble(z.doubleValue());
				}
			}
		}
	}

*/